import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import APIAmplify from '@aws-amplify/api';
import { I18n } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import { onStreamMessageChatAIResponse } from '@/graphql/subscriptions';
import LoadingChatAIMessage from '../LoadingChatAIMessage';
import { cloneDeep } from 'lodash';
import Constant from '@/common/constant/Constant';
import { buildConfirmIssuesResolvedMessage } from '@/component/publicPages/chatBot/handler/ChatBoxHandler';
import AIResponse from '@/component/chatAI/element/AIResponse';
import ThinkingLoading from './ThinkingLoading';
import { v4 as uuidv4 } from 'uuid';
import ThinkingInfo from './ThinkingInfo';

WaitingGPTResponseMessage.propTypes = {
    setListMessageContent: PropTypes.func,
    setIsEnableBtnSend: PropTypes.func,
    idOfResponseMessage: PropTypes.any,
    scrollToBottom: PropTypes.any,
    isFromChatBot: PropTypes.bool,
    categoryIdSelected: PropTypes.any,
    formQASystem: PropTypes.any,
    usingAI: PropTypes.any,

    isShowButtonStop: PropTypes.any,
    setIsShowButtonStop: PropTypes.any,
    isOnlyRunChatAI: PropTypes.any,
    setIsOnlyRunChatAI: PropTypes.any,

    streamedContent: PropTypes.any,
    setStreamedContent: PropTypes.any,

    isStopStreamContent: PropTypes.any,
    setIsStopStreamContent: PropTypes.any
};

export default function WaitingGPTResponseMessage({
    setListMessageContent,
    setIsEnableBtnSend,
    idOfResponseMessage,
    scrollToBottom,
    isFromChatBot,
    categoryIdSelected,
    formQASystem,
    usingAI,

    isShowButtonStop,
    setIsShowButtonStop,
    isOnlyRunChatAI,
    setIsOnlyRunChatAI,

    streamedContent,
    setStreamedContent,

    isStopStreamContent,
    setIsStopStreamContent,
    usingChatGptModel,
    usingReasoningEffort,
    setReasoningDataStream,
    resolvedMessages
}) {
    const [displayedMessages, setDisplayedMessages] = useState('');
    const [listItemMessage, setListItemMessage] = useState([]);
    const [reasoningData, setReasoningData] = useState([])
    const stopRef = useRef('');

    function unescapeJSONSpecialCharacters(str) {
        // Đảo ngược việc escape dấu gạch chéo
        str = str.replace(/\\\\/g, '\\');
        // Đảo ngược việc escape dấu ngoặc kép
        str = str.replace(/\\"/g, '"');
        // Đảo ngược việc escape dấu nháy đơn
        str = str.replace(/\\'/g, "'");
        // Đảo ngược việc escape ký tự dòng mới
        str = str.replace(/\\n/g, '\n');
        // Thay thế \^^ thành "
        str = str.replace(/\\\^\^/g, '"');
        str = str.replaceAll(/%\^&1/g, "'");
    
        return str;
    }

    function sortByIndex(array) {
        array.sort((a, b) => {
            return a.index - b.index;
        });
        return array;
    }

    const getFullMessage = (listMessage) => {
        let message = '';
        listMessage?.forEach(messageObject => {
            if(!messageObject.isEnd){
                message += messageObject.message
            }
        });
        return message;
    }

    // uef listen update listMessageContent
    useEffect(() => {
        let listMessageClone = cloneDeep(listItemMessage);
        if (!Utils.isEmptyArray(listItemMessage)) {
            listMessageClone = sortByIndex(listMessageClone);
            let message = '';
            for (let index = 0; index < listMessageClone.length; index++) {
                const itemMessage = listMessageClone[index];
                
                if (Number(itemMessage.index) === Number(index)) {
                    if (itemMessage.isEnd) {
                        message = getFullMessage(listMessageClone);
                        let responseMessage = {
                            isFromMe: false,
                            content: message,
                            dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                            messageType: Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.GPT_RESPONSE_MESSAGE,
                            postType: itemMessage.postType,
                            id: itemMessage?.id || itemMessage?.aiChatPostId,
                        };
                        setIsEnableBtnSend(true);
                        if(isFromChatBot) {
                            updateMessageProblemResolved(responseMessage);
                        } else {
                            updateLastMessage(responseMessage, itemMessage.isAddNewWaitingMessage);
                        }
                        break;
                    } else {
                        message += itemMessage.message;
                    }
                } else {
                    break;
                }
            }
            setDisplayedMessages(message);
            scrollToBottom()
        }
    }, [listItemMessage]);

    useEffect(() => {
    if (typeof setReasoningDataStream === 'function') {
        setReasoningDataStream([...reasoningData]);
    }
}, [reasoningData]);

    useEffect(() => {
        stopRef.current = isStopStreamContent;
    }, [isStopStreamContent]);
    // subscription stream response
    useEffect(() => {
        let accumulatedContent = '';
        let subscription;
        let subscriptionReasoning
        // let timeoutId;

        // const createTimeout = () => {
        //     return setTimeout(() => {
        //         subscription?.unsubscribe();
        //         let responseMessage = {
        //             isFromMe: false,
        //             content: I18n.get('MSG-PROCESSING-TIME-EXCEEDED'),
        //             isError: true,
        //             dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date())
        //         };
        //         updateLastMessage(responseMessage);
        //         setIsEnableBtnSend(true);
        //     }, 890000)
        // }

        if (idOfResponseMessage) {

            const handleReasoningEvent = subscriptionData => {
                let messageObject = subscriptionData?.value?.data?.onStreamMessageChatAIResponse;
                const detailtResponse = Utils.extractTitleAndContent(messageObject.message);
                if(stopRef.current === Constant.STREAM_STATUS.STOP){
                    return;
                }
                if(messageObject.isEnd){
                    return;
                };

                setReasoningData(prevData => [...prevData, detailtResponse]);
            }
            const handleSubscriptionEvent = subscriptionData => {
                let messageObject = subscriptionData?.value?.data?.onStreamMessageChatAIResponse;
                if(messageObject.message === 'WARNING_EXCEED_MAX_TOKEN'){
                    updateMessageExceedMaxToken();
                    if (typeof setIsOnlyRunChatAI === 'function') {
                        setIsOnlyRunChatAI(false)
                    }
                    if (typeof setIsShowButtonStop === 'function') {
                        setIsShowButtonStop(false);
                    }
                    if (typeof setStreamedContent === 'function') {
                        setStreamedContent('');
                    }
                    return;
                };

                if (messageObject.message.includes(Constant.CONSTANT_SYSTEM_CHAT_AI_MESSAGE_TYPE.ERROR_NOT_CONNECTED_CONNECTOR)) {
                    updateMessageNotConnectedConnector(messageObject.message);
                    if (typeof setIsOnlyRunChatAI === 'function') {
                        setIsOnlyRunChatAI(false)
                    }
                    if (typeof setIsShowButtonStop === 'function') {
                        setIsShowButtonStop(false);
                    }
                    if (typeof setStreamedContent === 'function') {
                        setStreamedContent('');
                    }
                    return;
                }

                // Check for unsupported model error message
                const isUnsupportedModelError = Constant.AI_ERROR_PATTERNS.UNSUPPORTED_MODEL.test(messageObject?.message);

                if (
                    messageObject?.message?.includes(I18n.get('MSG_OPEN_AI_API_ERROR_PATH_TERM')) ||
                    messageObject?.message === I18n.get('MSG-AI-LICENSE-KEY-HAVE-BEEN-INVALID-CONTACT-ADMIN') ||
                    isUnsupportedModelError
                ) {
                    let responseMessage = {
                        isFromMe: false,
                        content: messageObject?.message,
                        isError: true,
                        dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
                    };
                    if (typeof setIsOnlyRunChatAI === 'function') {
                        setIsOnlyRunChatAI(false)
                    }
                    if (typeof setIsShowButtonStop === 'function') {
                        setIsShowButtonStop(false);
                    }
                    if (typeof setStreamedContent === 'function') {
                        setStreamedContent('');
                    }

                    setListMessageContent((prevArray) => {
                        const newArray = [...prevArray];
                        if (newArray.length > 0) {
                            newArray[newArray.length - 1] = responseMessage;
                            return newArray;
                        }
                        return [responseMessage];
                    });
                    setIsEnableBtnSend(true);
                    return;
                }

                if (messageObject.isEnd) {
                    if (typeof setIsOnlyRunChatAI === 'function') {
                        setIsOnlyRunChatAI(false)
                    }
                    if (typeof setIsShowButtonStop === 'function') {
                        setIsShowButtonStop(false);
                    }
                    if (typeof setStreamedContent === 'function') {
                        setStreamedContent('');
                    }

                    if (messageObject.message === Constant.END_SDAUTO_LOG){
                        setListMessageContent(prevArray => {
                            // Tạo một bản sao của mảng hiện tại
                            let newArray = [...prevArray];
                
                            // Kiểm tra xem mảng có phần tử hay không
                            if (newArray.length > 0) {
                                // Cập nhật giá trị cuối cùng của mảng
                                newArray.pop();

                                return newArray
                            }
                
                            // Trường hợp mảng rỗng, trả về mảng chỉ chứa giá trị mới
                            
                            return prevArray;
                        });

                        setIsEnableBtnSend(true);
                    } else {
                        if (messageObject.message === I18n.get('MESG_STOP_STREAM_CONTENT_TO_CALL_FUNTION')) {
                            setListItemMessage(prevListMessage => [
                                ...prevListMessage,
                                {
                                    message: 'stop',
                                    index: messageObject.seq,
                                    isEnd: true,
                                    isAddNewWaitingMessage: true,
                                    postType: messageObject.postType || Constant.POST_TYPE.MSG,
                                    id: messageObject?.id || messageObject?.aiChatPostId,
                                }
                            ]);
                        } else {
                            if (typeof setIsShowButtonStop === 'function') {
                                setIsShowButtonStop(false);
                            }
                            if (typeof setStreamedContent === 'function') {
                                setStreamedContent('');
                            }

                            setListItemMessage(prevListMessage => [
                                ...prevListMessage,
                                {
                                    message: 'stop',
                                    index: messageObject.seq,
                                    isEnd: true,
                                    postType: messageObject.postType || Constant.POST_TYPE.MSG,
                                    id: messageObject?.id || messageObject?.aiChatPostId,
                                }
                            ]);
                        }
                    }
                } else {
                    const newMessageIndex = messageObject.seq;
                    const message = messageObject.message;
                    const displayText = unescapeJSONSpecialCharacters(message);

                    const newMsg = {
                        message: displayText,
                        index: newMessageIndex,
                        isEnd: false,
                        postType: messageObject.postType || Constant.POST_TYPE.MSG,
                        id: messageObject?.id || messageObject?.aiChatPostId,
                    }
                    if (isOnlyRunChatAI) {
                        if (stopRef.current === Constant.STREAM_STATUS.STOP) {
                            if (typeof setIsOnlyRunChatAI === 'function') {
                                setIsOnlyRunChatAI(false)
                            }
                            if (typeof setStreamedContent === 'function') {
                                setStreamedContent('');
                            }
                            setListItemMessage(prevListMessage => [
                                ...prevListMessage,
                                {
                                    message: 'stop',
                                    index: messageObject.seq,
                                    isEnd: true,
                                    postType: messageObject.postType || Constant.POST_TYPE.MSG,
                                    id: messageObject?.id || messageObject?.aiChatPostId,
                                }
                            ]);
                            subscription?.unsubscribe();
                            return;
                        }

                        accumulatedContent += displayText;
                        setStreamedContent?.(accumulatedContent);
                    }
                    
                    setListItemMessage(prevListMessage => [
                        ...prevListMessage,
                        newMsg
                    ]);

                    // update timeout when received message
                    // if(timeoutId){
                    //     clearTimeout(timeoutId);
                    // };
                    // timeoutId = createTimeout()

                }
            };


            subscription = APIAmplify.graphql({
                query: onStreamMessageChatAIResponse,
                variables: { aiChatPostId: idOfResponseMessage },
                authMode: Constant.AUTH_MODE_API_KEY
            }).subscribe({
                next: data => handleSubscriptionEvent(data),
                error: error => {
                    console.error('Subscription error:', error);
                    let responseMessage = {
                        isFromMe: false,
                        content: I18n.get('MSG-PROCESSING-TIME-EXCEEDED'),
                        isError: true,
                        dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date())
                    };
                    subscription.unsubscribe();
                    updateLastMessage(responseMessage);
                    setIsEnableBtnSend(true);
                }
            });

            const reasoningChatPostId = `${Constant.ID_PREFIX.REASONING_CHATPOST_PREFIX}${idOfResponseMessage}`;
            subscriptionReasoning = APIAmplify.graphql({
                query: onStreamMessageChatAIResponse,
                variables: { aiChatPostId: reasoningChatPostId },
                authMode: Constant.AUTH_MODE_API_KEY
            }).subscribe({
                next: data => handleReasoningEvent(data),
                error: error => {
                    subscriptionReasoning.unsubscribe();
                }
            });
        }

        return () => {
            if (subscription) {
                subscription.unsubscribe();
            }

            if(subscriptionReasoning){
                subscriptionReasoning.unsubscribe();
            }
        };
    }, [idOfResponseMessage]);

    const updateLastMessage = (newValueParam, isAddNewWaitingMessage = false) => {
        let newValue = cloneDeep(newValueParam);
        if(!Utils.isEmptyArray(reasoningData)){
            newValue.reasoningData = [...reasoningData, {isDone: true}];
        }
        setListMessageContent(prevArray => {
            let newArray = [newValue]
            if (prevArray.length > 0) {
                newArray = [...prevArray];
                newArray[newArray.length - 1] = newValue;

            }

            if (isAddNewWaitingMessage) {
                newArray.push({
                    isFromMe: false,
                    isLoadingMessage: true,
                    idOfLoadingMessage: uuidv4()
                });
            };
            return newArray;
        });
    };

    const updateMessageExceedMaxToken = newValue => {
        setListMessageContent(prevArray => {
            // Tạo một bản sao của mảng hiện tại
            let prevArrayClone = [...prevArray];
            // Kiểm tra xem mảng có phần tử hay không
            if (prevArrayClone.length > 1) {
              let nearEndItem = prevArrayClone[prevArrayClone.length-2];
              if(nearEndItem.isHidden){
                nearEndItem.isHidden = false;
                prevArrayClone[prevArrayClone.length-2] = nearEndItem
              }
            }

            // Trường hợp mảng rỗng, trả về mảng chỉ chứa giá trị mới
            return [...prevArrayClone];
        });
    };


    function getConnectorNamesFromMessage(message) {
           if (!message || typeof message !== 'string') return [];
            // Format: "<WARNING_CONST>: name1, name2, name3"
            const splitIndex = message.indexOf(':');
            if (splitIndex === -1) return [];
            const nameListPart = message.slice(splitIndex + 1).trim();
            if (!nameListPart) return [];
            return nameListPart.split(',').map(name => name.trim()).filter(Boolean);
    }

    const updateMessageNotConnectedConnector = newValue => {
        let listNotConnectedConnector = getConnectorNamesFromMessage(newValue);
        let responseMessage = {
            isFromMe: false,
            content: '',
            dateTime: Utils.getDateTimeByFormatJapanYYYY_MM_DDHHMM(new Date()),
            type: Constant.CONSTANT_SYSTEM_CHAT_AI_MESSAGE_TYPE.ERROR_NOT_CONNECTED_CONNECTOR,
            listNotConnectedConnector: listNotConnectedConnector
        };
        setListMessageContent((prevArray) => {
            const newArray = [...prevArray];
            if (newArray.length > 0) {
                newArray[newArray.length - 1] = responseMessage;
                return newArray;
            }
            return [responseMessage];
        });
        setIsEnableBtnSend(true);
    };

    const updateMessageProblemResolved = newValue => {
        const newMessage = buildConfirmIssuesResolvedMessage(categoryIdSelected, formQASystem, null, usingAI, resolvedMessages);
        newMessage.messageChatAI = '※別の言い回しで再度質問することもできます。';
        setListMessageContent(prevArray => {
            const newArray = [...prevArray];
            if (newArray.length > 0) {
                newArray[newArray.length - 1] = newValue;
                newArray.push(newMessage);
                return newArray;
            }
            return [newValue];
        });
    }

    return (
    <>
      {Utils.isEmptyString(displayedMessages) && !Utils.isEmptyArray(reasoningData) && OpenAiUtil.isSupportReasoning(usingChatGptModel) ? <ThinkingLoading
            reasoningData={reasoningData}
        />
         :<>
        {!Utils.isEmptyArray(reasoningData) && OpenAiUtil.isSupportReasoning(usingChatGptModel) && <ThinkingInfo
            reasoningData={[...reasoningData, {isDone: true}]}
        />}
          <LoadingChatAIMessage
            displayedMessages={
                <AIResponse
                    data={displayedMessages}
                    isWaitingChat={true}
                    isPublicSite={isFromChatBot}
                />
            }
        />
        </>
        }
    </>
    )
};
